import { api } from '../axios'

export default {
  completeHubspotConnection: async code => {
    const res = await api.get(`/hubspot/oauth/callback`, { params: { code } })
    return res.data
  }
}
